<template>
    <div class="relative transition duration-100 block border border-gray-200 rounded p-2 dark:border-gray-600"
         @click="focusTextarea"
         :class="{'bg-gray-100 dark:bg-slate-700 cursor-pointer': compactMode, 'ring ring-blue-500/50 border-blue-500': focused}"
    >
        <Mentionable
            v-show="!compactMode"
            :keys="['@']"
            :items="suggests"
            @open="loadSuggests"
            @search="loadSuggests($event)"
            filtering-disabled
        >
            <textarea
                ref="textarea"
                v-autogrow="150"
                @keydown="processKey"
                @focus="focusTextarea"
                @blur="blurTextarea"
                @paste="parsePaste"
                class="resize-none overflow-hidden overflow-y-auto border-0 p-2 bg-transparent dark:text-white focus:outline-0 focus:outline-none focus:ring-0 w-full"
                v-model="form.body"></textarea>

            <template #no-result>
                <div class="p-1 px-2 text-gray-500 dark:text-slate-400">
                    {{ mentionLoading ? 'падажжи...' : 'не знаю такого юзера' }}
                </div>
            </template>

            <template #item-@="{ item }">
                <div
                    class="p-1 px-2 cursor-pointer hover:bg-blue-50 dark:hover:bg-slate-700 dark:hover:text-white flex space-x-2 items-center">
                    <avatar :ava="item.ava" class="w-4 h-4"></avatar>
                    <div class="truncate ">{{ item.label }}</div>
                </div>
            </template>

        </Mentionable>
        <div v-if="mentionPopup" ref="mentionPopup"
             class="z-50 w-40 absolute card card-white p-2 shadow border border-gray-300 dark:border-slate-500 max-h-40 overflow-y-auto">
            <div v-if="mentionLoading" class="p-2 text-center text-gray-400 dark:text-slate-500">
                Подождите
            </div>
            <div v-else class="text-sm">
                <div v-if="suggests.length">
                    <div v-for="item in suggests" :key="item.id" @click="mention(item.type, item.id)"
                         class="p-1 px-2 truncate cursor-pointer hover:bg-blue-50 dark:hover:bg-slate-700">
                        {{ item.name }}
                    </div>
                </div>
                <div v-else class="p-2 text-center text-gray-400 dark:text-slate-500">
                    не найдено
                </div>
            </div>
        </div>

        <div class="flex space-x-4 justify-between items-center">
            <upload-image :blobs="blobs"
                          :model-value="form.images"
                          @update:modelValue="updateImages"></upload-image>

            <div class="flex items-center space-x-4">
                <div v-if="comment" @click="$emit('closeForm')" class="text-gray-500 text-sm cursor-pointer">
                    Отмена
                </div>
                <button @click.prevent="sendComment(null)" :disabled="disabled"
                        :class="{'btn-sm': this.reply || this.comment, 'btn-md': !this.reply && !this.comment}"
                        class="btn btn-primary btn-md">
                    <div class="hidden md:block">
                        {{ buttonLabel }}
                    </div>
                    <svg-icon icon="send" class="w-4 h-4 md:hidden"></svg-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import Client from "../../js/modules/Client";
import UploadImage from "./../partials/uploadImage";
import {Mentionable} from 'vue-mention'
import Avatar from "../partials/Avatar.vue";
import SvgIcon from "../partials/SvgIcon.vue";

export default {
    components: {SvgIcon, Avatar, UploadImage, Mentionable},
    props: [
        'focus',
        'reply',
        'compact',
        'comment',
        'postid',
        'parent_id',
        'prefix',
    ],
    data() {
        let form = this.getForm();
        return {
            compactMode: this.compact || false,
            loading: false,
            blobs: [],
            form: form,
            focused: false,
            mentionString: null,
            mentionPopup: false,
            mentionLoading: false,
            suggests: [],
        }
    },
    mounted() {
        if (this.focus) {
            this.focusTextareaWithTimeout();
        }
    },
    methods: {
        focusTextareaWithTimeout() {
            setTimeout(() => {
                if (this.$refs.textarea) {
                    this.$refs.textarea.focus();
                }
            }, 100)
        },
        async loadSuggests(searchText = null) {
            if (searchText) {
                this.mentionLoading = true;
                await Client.post('/api/v1.1/user/suggest', {
                    name: searchText,
                }).then(response => {
                    this.suggests = response.data.data;
                    this.mentionLoading = false;
                }).catch(error => {
                    this.mentionLoading = false;
                })
            } else {
                this.mentionLoading = false;
            }
        },
        focusTextarea(event) {
            this.focused = true;

            if (this.compactMode) {
                event.preventDefault();
                this.compactMode = false;
                this.focusTextareaWithTimeout();
                //Caret.setPosition(this.$refs.textarea, this.$refs.textarea.innerHTML.length);
            }
            this.$emit('focus');
        },
        blurTextarea() {
            this.focused = false;
            this.$emit('blur');
        },
        deepCopy(obj) {
            let outObject, value, key;

            if (typeof obj !== "object" || obj === null) {
                return obj; // Return the value if obj is not an object
            }

            // Create an array or object to hold the values
            outObject = Array.isArray(obj) ? [] : {};

            for (key in obj) {
                value = obj[key];
                // Recursively (deep) copy for nested objects, including arrays
                outObject[key] = this.deepCopy(value);
            }

            return outObject;
        },
        updateImages(value) {
            this.form.images = value;
            this.blobs = [];
        },
        parsePaste(event, callback) {
			if (typeof (callback) == "function") {
				callback(undefined);
			}

            if (event.clipboardData === false) {
                if (typeof (callback) == "function") {
                    callback(undefined);
                }
            }

            let items = event.clipboardData.items;

            if (items === undefined) {
                if (typeof (callback) == "function") {
                    callback(undefined);
                }
            }

            if (items.length) {
                for (let i = 0; i < items.length; i++) {
                    let isImg = items[i].type.indexOf("image") !== -1;
                    let isVideo = items[i].type.indexOf("video") !== -1;

                    if (!isImg && !isVideo) continue;
                    this.blobs.push(items[i].getAsFile());
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        },
        processKey(event) {
            if ((event.metaKey || event.ctrlKey) && event.keyCode === 13) {
                this.sendComment();
            }
        },
        getForm() {
            if (this.comment) {
                let comment = this.deepCopy(this.comment);
                return {
                    parent_id: comment.parent_comment_id,
                    body: (this.prefix ?? '') + comment.body_raw,
                    images: comment.images ?? [],
                };
            }

            return {
                parent_id: this.parent_id,
                body: (this.prefix ?? '') + '',
                images: [],
            };
        },
        sendComment() {
            let hasComment = this.form.body && this.form.body.length;
            let isNotEmpty = hasComment || this.form.images.length;

            if (isNotEmpty && !this.loading) {
                this.loading = true;

                // Редактирование
                if (this.comment) {
                    Client.patch('/api/v1.1/posts/' + this.postid + '/comments/' + this.comment.id, this.form)
                        .then(response => {
                            this.$emit('commentUpdated', response.data.data);
                            this.resetForm();
                            this.loading = false;
                        })
                        .catch(error => {
                            notify({
                                type: 'error',
                                text: error.response.data.message || 'Ошибка, жаль',
                            });
                            this.loading = false;
                        });
                } else {
                    Client.post('/api/v1.1/posts/' + this.postid + '/comments', this.form)
                        .then(response => {
                            this.$emit('commentAdded', response.data.data);
                            this.resetForm();
                            this.loading = false;
                        })
                        .catch(error => {
                            let message = error.response?.data?.message;

                            notify({
                                type: 'error',
                                text: message ?? 'Ошибка отправки',
                            });
                            this.loading = false;
                        });
                }
            }
        },
        resetForm() {
            this.$refs.textarea.innerText = '';
            this.$refs.textarea.style.height = 'auto';
            this.$refs.textarea.style.maxHeight = 'auto';
            this.form.body = '';
            this.form.images = [];
            this.blobs = [];
        },
    },
    computed: {
        disabled() {
            if (this.loading) {
                return true;
            }

            if (this.comment && this.comment.body_raw === this.form.body && this.comment.images === this.form.images) {
                return true;
            }

            return false;
        },
        buttonLabel() {
            return this.comment ? 'Редактировать' : 'Отправить';
        },
    }
}
</script>
